
export const isRecipePage = ()=> {
    const url = window?.location.href
    console.log('window?.location', window?.location)
    if(url?.includes('recipes')) return true
    else if(url?.includes('share')) return true
    return false
}